module.exports = __webpack_public_path__ + "9788f41e/img/verified-icon.f93bbc14.svg";